import React from "react";
import GoogleMapReact from "google-map-react";
import styles from "./index.module.scss";
import imgLocation from "./location.png";
var Marker = function (props) {
    return React.createElement("div", { className: styles.loc, style: {
            position: "absolute",
            transform: "translate(-50%, -100%)",
        } },
        React.createElement("img", { src: imgLocation, alt: "location" }));
};
export var Map = function () {
    var location = {
        lat: 48.430766821187994,
        lng: 2.1516028079676923,
    };
    var defaultProps = {
        center: location,
        zoom: 13,
    };
    return React.createElement("div", { className: styles.container },
        React.createElement("div", { className: "title", style: {
                color: "white",
            } }, "localisation de la c\u00E9r\u00E9monie"),
        React.createElement("div", { className: styles.map },
            React.createElement(GoogleMapReact, { bootstrapURLKeys: { key: "AIzaSyDfrXQ_i3xKEaG4-AaYE9yUfNntzX5aRkU" }, defaultCenter: defaultProps.center, defaultZoom: defaultProps.zoom },
                React.createElement(Marker, { lat: location.lat, lng: location.lng, markerPosition: "center center" }))));
};
